<template>
    <div class="app-body">
        <div class="a-flex-rsbc a-ptb-6">
            <span class="a-fs-16 a-fw-700">平台收益提现</span>
            <div class="a-flex-rcc">
                <el-button icon="el-icon-upload2" class="s-btn-exp" @click="exportfile">导出</el-button>
            </div>
        </div>
        <el-card class="el-main">
            <le-search-form @reset="handlerRest" @search="handlerSearch" :canPackUp="false" id="leSearch">
                <le-date-range label="结算日期" :pickerOptions="pickerOptions" :minDate.sync="pageParam.params.countStartDate" :maxDate.sync="pageParam.params.countEndDate" valueFormat="yyyy-MM-dd HH:mm:ss"  />
                <le-date-range label="预计到账日期" :pickerOptions="pickerOptions" :minDate.sync="pageParam.params.expectPayoutStartDate" :maxDate.sync="pageParam.params.expectPayoutEndDate" valueFormat="yyyy-MM-dd HH:mm:ss"  />
                <le-date-range label="实际到账日期" :pickerOptions="pickerOptions" :minDate.sync="pageParam.params.realPayoutStartDate" :maxDate.sync="pageParam.params.realPayoutEndDate" valueFormat="yyyy-MM-dd HH:mm:ss"  />
                <!-- <le-company-under-select label="结算商户" placeholder="请选择（可输入搜索）" v-model="companyId"></le-company-under-select> -->
                <le-select-remote-search label="结算商户" v-model="pageParam.params.companyId" :options="optionsCompany" placeholder="请选择结算商户(可搜索)" />
                <le-select-local-search label="钱包" v-model="pageParam.params.payPlatform" :options="payPlatformDic" />
                <le-select-local-search label="提现状态" v-model="pageParam.params.withdrawStatusList" multiple :options="withdrawStatusDic" />
            </le-search-form>
            <le-pagview ref="financeSYRZ" @setData="setTableData" :pagerCount="5" :pageParam="pageParam" :isFixed="true" :tableRef="$refs.financeSYRZList">
                <el-table ref="financeSYRZList" :data="tableData" :highlight-current-row="true" v-sticky="{ top: 0, parent:'.el-card__body' }" style="width: 100%">
                    <el-table-column prop="countDate" label="结算日期" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ row.countDate?row.countDate:'-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="companyName" label="结算商户" min-width="200">
                        <template slot-scope="{ row }">
                            <span>{{ row.companyName?row.companyName:'-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="countDate" label="钱包" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ row.payPlatform | initDic(payPlatformDic) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="orderPrice" label="分账收益" min-width="123">
                        <template slot="header" slot-scope="scope">
                            <div class="a-flex-rfsc">
                                <span>分账收益</span>
                                <el-tooltip class="item" effect="dark" content="商户在该支付渠道当日获得的分账收益" placement="top">
                                    <span class="el-icon-question"></span>
                                </el-tooltip>
                            </div>
                        </template>
                        <template slot-scope="{ row }">
                            <span>￥{{ util.numFormat(row.incomeAmount) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="incomePrice" label="提现手续费" min-width="123">
                        <template slot="header" slot-scope="scope">
                            <div class="a-flex-rfsc">
                                <span>提现手续费</span>
                                <el-tooltip class="item" effect="dark" content="支付渠道提现时收取" placement="top">
                                    <span class="el-icon-question"></span>
                                </el-tooltip>
                            </div>
                        </template>
                        <template slot-scope="{ row }">
                            <span>￥{{ util.numFormat(row.withdrawFee) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="incomePrice" label="应到账金额" min-width="123">
                        <template slot="header" slot-scope="scope">
                            <div class="a-flex-rfsc">
                                <span>应到账金额</span>
                                <el-tooltip class="item" effect="dark" content="预计实际银行到账金额" placement="top">
                                    <span class="el-icon-question"></span>
                                </el-tooltip>
                            </div>
                        </template>
                        <template slot-scope="{ row }">
                            <span>￥{{ util.numFormat(row.deserveAmount) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="incomePrice" label="实际到账" min-width="123">
                        <template slot="header" slot-scope="scope">
                            <div class="a-flex-rfsc">
                                <span>实际到账</span>
                                <el-tooltip class="item" effect="dark" content="实际提现到账的金额" placement="top">
                                    <span class="el-icon-question"></span>
                                </el-tooltip>
                            </div>
                        </template>
                        <template slot-scope="{ row }">
                            <span>￥{{ util.numFormat(row.realAmount) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="incomePrice" label="预计到账日期" min-width="123">
                        <template slot="header" slot-scope="scope">
                            <div class="a-flex-rfsc">
                                <span>预计到账日期</span>
                                <el-tooltip class="item" effect="dark" content="预计提现到银行账户的日期" placement="top">
                                    <span class="el-icon-question"></span>
                                </el-tooltip>
                            </div>
                        </template>
                        <template slot-scope="{ row }">
                            <span>{{ row.expectPayoutDate || '-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="incomePrice" label="实际到账日期" min-width="123">
                        <template slot="header" slot-scope="scope">
                            <div class="a-flex-rfsc">
                                <span>实际到账日期</span>
                                <el-tooltip class="item" effect="dark" content="提现到银行账户的实际日期" placement="top">
                                    <span class="el-icon-question"></span>
                                </el-tooltip>
                            </div>
                        </template>
                        <template slot-scope="{ row }">
                            <span>{{ row.realPayoutDate || '-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="incomePrice" label="提现状态" min-width="123">
                        <template slot="header" slot-scope="scope">
                            <div class="a-flex-rfsc">
                                <span>提现状态</span>
                                <el-tooltip class="item" effect="dark" placement="top">
                                    <div slot="content">
                                        待提现：尚未到账；<br>
                                        已提现：提现已到账，且应到账金额等于实际到账金额；<br>
                                        提现异常：提现失败或虽已到账但应到账金额不等于实际到账金额；<br>
                                    </div>
                                    <span class="el-icon-question"></span>
                                </el-tooltip>
                            </div>
                        </template>
                        <template slot-scope="{ row }">
                            <span>{{ row.withdrawStatus | initDic(withdrawStatusDic) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="myOrderNum" label="异常原因" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ row.errorReason || '-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="name" label="操作" width="75" fixed="right">
                        <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark" content="提现详情" placement="top">
                                <img src="../../assets/icon/option-detail.png" class="a-wh-16" @click="toWithdrawInfo(scope.row)" />
                            </el-tooltip>
                        </template>
                    </el-table-column>
                </el-table>
                <template slot="footerContent" slot-scope="scope" >
                    <div class="a-flex-rfsc">
                        <div class="a-flex-rfsc" style="margin-right: 40px">
                            <span class="a-fs-12 a-c-normal">分账收益：</span>
                            <span class="a-fs-16 a-c-master a-fw-b">￥{{util.numFormat(scope.val.incomeAmount)}}</span>
                        </div>
                        <div class="a-flex-rfsc" style="margin-right: 40px">
                            <span class="a-fs-12 a-c-normal">应到账金额：</span>
                            <span class="a-fs-16 a-c-master a-fw-b">￥{{util.numFormat(scope.val.deserveAmount)}}</span>
                        </div>
                        <div class="a-flex-rfsc">
                            <span class="a-fs-12 a-c-normal">实际到账：</span>
                            <span class="a-fs-16 a-c-master a-fw-b">￥{{util.numFormat(scope.val.realAmount)}}</span>
                        </div>
                    </div>
                </template>
            </le-pagview>
        </el-card>
    </div>
</template>

<script>
    import util from '../../../src/utils/util'
    export default {
        data () {
            return {
                tableData: [],
                util: util,
                pageParam: {
                    url: this.$Config.apiUrl.sysCompanyWithdrawPage,
                    method: "post",
                    params: {
                        companyId: '',
                        countStartDate: this.$getDay.getTodayBeforeDays(30) + ' 00:00:00',
                        countEndDate: this.$getDay.getTodayBeforeDays(0) + ' 23:59:59',
                        expectPayoutEndDate: '',
                        expectPayoutStartDate: '',
                        payPlatform: '',
                        realPayoutEndDate: '',
                        realPayoutStartDate: '',
                        withdrawStatusList: [],
                    },
                    freshCtrl: 1,
                },
                choiceDate: '',
                pickerOptions: {
                    onPick: ({ maxDate, minDate }) => {
                        this.choiceDate = minDate.getTime()
                        if (maxDate) this.choiceDate = ''
                    },
                    disabledDate: (time) => {
                        if (this.choiceDate) {
                            const one = 92 * 24 * 3600 * 1000
                            const minTime = this.choiceDate - one
                            const maxTime = this.choiceDate + one
                            return time.getTime() < minTime || time.getTime() > maxTime
                        }
                    },
                },
                optionsCompany: {
                    url: this.$Config.apiUrl.getSysCompanyList,
                    method: "get",
                    params: {},
                    showLoading: false,
                    labelKey: "companyName",
                    valueKey: "companyId",
                    searchKey: "companyName",
                    pageSize: 100
                },
                payPlatformDic: [],
                withdrawStatusDic: []
            }
        },
        created () {
            this.$getDic('payPlatform','select').then(res=>{ this.payPlatformDic = res; })
            this.$getDic('checkWithdrawStatus','select').then(res=>{ this.withdrawStatusDic = res; })
        },
        activated () {
            this.pageParam.freshCtrl++;
        },
        methods: {
            //获取设备列表
            setTableData(data) {
                this.tableData = data;
            },
            handlerRest() {
                this.pageParam.params = {
                    companyId: '',
                    countStartDate: '',
                    countEndDate: '',
                    expectPayoutEndDate: '',
                    expectPayoutStartDate: '',
                    payPlatform: '',
                    realPayoutEndDate: '',
                    realPayoutStartDate: '',
                    withdrawStatusList: [],
                };
                this.handlerSearch()
            },
            handlerSearch() {
                this.$refs['financeSYRZ'].pageNum = 1
                this.pageParam.freshCtrl++;
            },
            // 查看提现详情
            toWithdrawInfo (datas) {
                if(!datas.withdrawId) {
                    this.$message.warning('提现单尚未生成')
                    return
                }
                this.$router.push({
                    path: `/withdrawal/withdrawal-detail?code=${datas.withdrawId}`
                })
            },
            exportfile () {
                let startDate = this.pageParam.params.countStartDate || this.$getDay.getTodayBeforeDays(92) + ' 00:00:00'
                let endDate = this.pageParam.params.countEndDate || this.$getDay.getTodayBeforeDays(0) + ' 00:00:00'
                this.$exfile({
                    code: 36,
                    fileName: `结算日期${startDate} 至 ${endDate}平台收益提现表`,
                    startTime: startDate.split(' ')[0],
                    endTime: endDate.split(' ')[0],
                    params: {
                        ...this.pageParam.params,
                        countStartDate: startDate,
                        countEndDate: endDate
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    /deep/ .s-search-label{
        width: 100px !important;
    }
    /deep/ .el-table__body-wrapper::-webkit-scrollbar {
		/*width: 0;宽度为0隐藏*/
		width: 0 !important;
		height: 0 !important;
	}
	/deep/ .el-table__fixed, /deep/ .el-table__fixed-right{
		height: 100% !important;
	}
</style>